import AudioFactory from 'scripts/application/lib/audio_factory';
import { NotificationSoundType } from 'actions/notification/lib/notification_constants';

export default function playNotificationSound(type) {
  let soundSrc = getSoundUrlByType(type);
  if (soundSrc) {
    let audio = AudioFactory.create();
    audio.src = soundSrc;
    audio.play();
  }
}

function getSoundUrlByType(type) {
  switch (type) {
    case NotificationSoundType.DECLINED_SESSION_REASSIGNMENT:
    case NotificationSoundType.INCOMING_CONCURRENT_MESSAGE:
      return '/audio/cuteclicks.mp3';
    default:
      return undefined;
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/notification/lib/play_notification_sound.js